import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { hashEmail } from "@utils/EmailUtils";
export var onUserStatusSet = email => __awaiter(void 0, void 0, void 0, function* () {
  window.dataLayer.push(Object.assign({
    event: "user_status"
  }, email && {
    hashedEmail: yield hashEmail(email)
  }));
});